// extracted by mini-css-extract-plugin
export default {"address":"style_address__pINZw","address1":"style_address1__nGPdI","address2":"style_address2__5IZR+","city":"style_city__QMBE0","zip":"style_zip__4jGfM"};